'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = undefined;
exports.persistState = persistState;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _logger = require('@virtuous/logger');

var _LocalStorageAdapater = require('./adapters/LocalStorageAdapater');

var _LocalStorageAdapater2 = _interopRequireDefault(_LocalStorageAdapater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultPaths = [];

function getSubset(state) {
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultPaths;

  if (!paths.length) {
    return state;
  }

  var subset = {};

  paths.forEach(function (entry) {
    (0, _set2.default)(subset, entry, (0, _get2.default)(state, entry));
  });

  return subset;
}

function persistState(config) {
  var _config$key = config.key,
      key = _config$key === undefined ? 'redux' : _config$key,
      _config$paths = config.paths,
      paths = _config$paths === undefined ? [] : _config$paths,
      _config$adapter = config.adapter,
      adapter = _config$adapter === undefined ? _LocalStorageAdapater2.default : _config$adapter,
      _config$logEngine = config.logEngine,
      logEngine = _config$logEngine === undefined ? _logger.logger : _config$logEngine;


  return function handleCreateStore(createStore) {
    return function (reducer, initialState, enhancer) {
      var store = createStore(reducer, initialState, enhancer);

      store.subscribe(function () {
        var state = store.getState();
        var subset = getSubset(state, paths);

        adapter.set(key, subset, (0, _debounce2.default)(function (error) {
          if (error) {
            logEngine.error('Warning: Unable to persist redux state:', error);
          }
        }, 100));
      });

      return store;
    };
  };
}

exports.storage = _LocalStorageAdapater2.default;